import { ReactComponent as FacebookIcon } from "assets/svg/social-icons/facebook.svg";
import { ReactComponent as LinkedInIcon } from "assets/svg/social-icons/linkedin.svg";
import { ReactComponent as RedditIcon } from "assets/svg/social-icons/reddit.svg";
import { ReactComponent as TwitterIcon } from "assets/svg/social-icons/twitter.svg";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import getClasses from "utils/getClasses";
import styles from "./ShareThisArticle.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";

interface Props {
  blog: any;
  amplitudePageName: AmplitudePageName;
}

const ShareThisArticle = ({ blog, amplitudePageName }: Props) => {
  const { isPhonePortrait } = usePhonePortraitContext();

  const urlEncoded = encodeURIComponent(window.location.href);
  const blogTitleEncoded = encodeURIComponent(blog.title);

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${urlEncoded}&quote=${blogTitleEncoded}`;
  const linkedinUrl = `https://www.linkedin.com/shareArticle?url=${urlEncoded}&title=${blogTitleEncoded}`;
  const twitterUrl = `https://twitter.com/intent/tweet?url=${urlEncoded}&text=${blogTitleEncoded}`;
  const redditUrl = `https://www.reddit.com/submit?url=${urlEncoded}&title=${blogTitleEncoded}`;

  return (
    <div
      className={getClasses(
        styles["share-this-article"],
        isPhonePortrait && styles["share-this-article--phone"],
      )}
    >
      <div className={styles["share-this-article__title"]}>
        Share this article
      </div>
      <div className={styles["share-this-article__links-container"]}>
        <a
          href={facebookUrl}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            track(amplitudePageName, "facebook-share-icon", "click");
          }}
        >
          <FacebookIcon />
        </a>
        <a
          href={linkedinUrl}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            track(amplitudePageName, "linkedin-share-icon", "click");
          }}
        >
          <LinkedInIcon />
        </a>
        <a
          href={twitterUrl}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            track(amplitudePageName, "twitter-share-icon", "click");
          }}
        >
          <TwitterIcon />
        </a>
        <a
          href={redditUrl}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            track(amplitudePageName, "reddit-share-icon", "click");
          }}
        >
          <RedditIcon />
        </a>
      </div>
    </div>
  );
};

export default ShareThisArticle;
